import { EXPERTISE } from './expertise';
import { THEMATIC } from './thematic';

export type COMMON_THEMATIC = THEMATIC | EXPERTISE;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const COMMON_THEMATIC = {
  ...THEMATIC,
  ...EXPERTISE,
};
